








import { Component, Vue } from "vue-property-decorator";
import FormularioFestival from "@/components/Formularios/FormularioFestival.vue";

@Component({
  components: {
    FormularioFestival
  },
  meta: {
    // sets document title
    title:
      "Ficha de Inscripción XLV Festival Folclórico en la patagonia 2026 - Ilustre Municipalidad de Punta Arenas",
    // optional; sets final title as "Index Page - My Website", useful for multiple level meta
    //titleTemplate: title => `${title} - My Website`,

    // meta tags
    meta: {
      description: {
        name: "description",
        content: "Ilustre Municipalidad de Punta Arenas"
      },
      keywords: { name: "keywords", content: "Punta Arenas" },
      equiv: {
        "http-equiv": "Content-Type",
        content: "text/html; charset=UTF-8"
      }
    }
  }
})
export default class FestivalView extends Vue {
  private mounted() {
    document.title =
      "Ficha de Inscripción XLV Festival Folclórico en la patagonia 2026 - Ilustre Municipalidad de Punta Arenas";
  }
}
